import { FC } from 'react'

import { Select } from '@forto-dev/phoenix-ui-core/common'

import { isValidLanguageCode, useLocalisation } from '@/utils/localisation'

export const LanguageSwitcher: FC = () => {
  const { currentLanguage, changeLanguage, supportedLanguages } = useLocalisation()

  return (
    <Select
      value={currentLanguage}
      onChange={(newLanguage) => {
        if (isValidLanguageCode(newLanguage)) {
          changeLanguage(newLanguage)
        }
      }}
      items={supportedLanguages.map((language) => ({
        value: language.code,
        label: language.name,
      }))}
    />
  )
}
